// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptyModule_empty__TnLmq","text":"EmptyModule_text__T2OoF"};